module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvaWNvbnMvbXN0aWxlLTcweDcwLnBuZyI7"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mstile-70x70.png
// module id = 6WZH
// module chunks = 0